import { Route, Routes } from "react-router-dom";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

import E2DownloadCenter from "./E2DownloadCenter/main";
import E2Positions from "./E2Positions/main";
import E2DynamicData from "./E2DynamicData/main";

export default function E2Routes() {
  return (
    <Routes>
      <Route
        path={`${Clients.E2}_download_center/*`}
        element={<E2DownloadCenter />}
      />
      <Route path={`${Clients.E2}_positions/*`} element={<E2Positions />} />
      <Route path={`${Tables.E2_DYNAMIC_DATA}/*`} element={<E2DynamicData />} />
    </Routes>
  );
}
